<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="커뮤니티" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>커뮤니티</template>

            <div class="page-section__content">
                <div class="sub-tabs">
                    <v-tabs grow hide-slider centered v-model="tab" class="v-tabs--density-compact">
                        <template v-for="(item, index) in items">
                            <tab-quarternary :key="index">
                                {{ item.name }}
                            </tab-quarternary>
                        </template>
                    </v-tabs>
                </div>
            </div>

            <div class="page-section__content">
                <v-tabs-items v-model="tab" class="community-tabs-items">
                    <template v-for="(item, index) in items">
                        <v-tab-item eager :key="index">
                            <div class="image-wrap">
                                <v-img eager :src="item.image">
                                    <v-sheet height="100%" color="transparent" class="pa-18px pa-md-40px">
                                        <v-row class="row--sm flex-column h-100 my-0">
                                            <v-spacer />
                                            <v-col cols="auto">
                                                <tit class="tit--lg white--text line-height-1">
                                                    {{ item.name }}
                                                </tit>
                                            </v-col>
                                            <v-col cols="auto" class="pb-0">
                                                <txt class="txt--lg white--text line-height-11">
                                                    {{ item.text }}
                                                </txt>
                                            </v-col>
                                        </v-row>
                                    </v-sheet>
                                </v-img>
                            </div>
                        </v-tab-item>
                    </template>
                </v-tabs-items>
                <v-row no-gutters justify="end">
                    <v-col cols="auto">
                        <txt class="txt--sm txt--dark mt-8px">* 실제 조성 이미지가 아닌 이해를 돕기 위한 이미지 입니다.</txt>
                    </v-col>
                </v-row>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import TabQuarternary from "@/components/publish/parents/tabs/tab-quarternary.vue";
import SheetSecondary from "@/components/publish/parents/sheets/sheet-secondary.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";
import Txt from "@/components/publish/styles/typography/txt.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        TabQuarternary,
        SheetSecondary,
        Tit,
        Txt,
    },
    data() {
        return {
            tab: null,
            items: [
                {
                    name: "맘스카페",
                    text: "육아중인 신혼부부 입주민들을 위한 커뮤니티 공간과 휴식공간 제공합니다.",
                    image: "/images/sub/complex/community/community-1.jpg",
                },
                {
                    name: "스터디룸",
                    text: "27층 최상층에 설치된 스터디룸에서 멋진 풍경과 함께 자기개발 또는 독서를 해보세요!",
                    image: "/images/sub/complex/community/community-2.jpg",
                },
                {
                    name: "공유주방",
                    text: "전자레인지 및 싱크대등 편의시설을 배치하여 입주민이 함께 모여 식사 및 친목도모가 가능합니다.",
                    image: "/images/sub/complex/community/community-3.jpg",
                },
                {
                    name: "코인세탁실",
                    text: "입주민들을 위한 세탁서비스. 세탁시간동안 지루하지 않게 간이 의자를 배치하여 휴식공간을 제공해드립니다.",
                    image: "/images/sub/complex/community/community-4.jpg",
                },
                {
                    name: "공동작업실",
                    text: "주민들이 모여서 다양한 활동과 업무를 할 수 있도록 테이블 및 수납장을 배치하였습니다.",
                    image: "/images/sub/complex/community/community-5.jpg",
                },
                {
                    name: "주민회의실",
                    text: "입주민들의 중요한 안건을 상정 하고 결정하는 공간을 제공합니다.",
                    image: "/images/sub/complex/community/community-6.jpg",
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.community-tabs-items {
    position: relative;
    &::before {
        position: absolute;
        display: block;
        content: "";
        top: 55px;
        left: 55px;
        width: 80vw;
        height: 100%;
        background: url(/images/sub/complex/community/marble-background.svg) no-repeat;
        background-size: contain;
        z-index: -1;
    }
}
</style>
